/*eslint-disable */
define(function (require) {
    'use strict';

    var Backbone = require('backbone');

    var BasketSummaryModel = Backbone.Model.extend({
        defaults: {
        	date: '',
        	time: '',
        	basket: [],
            canRemoveSkus: true,
            canAddMoreServices: true,
            showTotals: true,
            disableContinueButton: false
        }
    });

    return BasketSummaryModel;
});